import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";

@Component({
    selector: "vehicledriverlocation",
    template: require('./vehicledriverlocation.component.html'),
    styles: [require('./vehicledriverlocation.component.css')]
})
export class VehicleDriverLocationComponent implements OnChanges {

    report: CollisionReport;
    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router) {
        this.report = appcomponent.getReport();
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }
        //if (this.report.FiveDigitCode == null || this.report.FiveDigitCode == 0) {
        //    this.router.navigate(["home"]);
        //}

        if (this.report.IsNew) {
            this.router.navigate(["home"]);
        }

        if (this.report.EntityType != null && this.report.EntityType == "CYCLIST") {
            this.report.VehicledriverlocationVehicleType = "36";
        }

        document.body.scrollTop = 0;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
                //DO SOmething
            }
        }
        else
            console.log("Undefined");
    }

    onBack(): void {
        this.BackAndPost("witness");
    }

    private BackAndPost(page: string): void {

        this.report.CurrentPage = page;
        // this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }

    onSubmit(): void {
        // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.report));
        // this.ValidateAndPost("trafficevent");
        this.ValidateAndPost("environment");
        //environment
        //GO TO NEXT PAGE
    }

    private ValidateAndPost(page: string) {
        this.report.IsVehicleDriverLocationPageValid = true;
        this.report.CurrentPage = page;
        this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                if (typeof v.EntityType == 'undefined' || v.EntityType == null || v.EntityType == "") {
                    this.router.navigate(["home"]);
                }
                this.report = v;
            });
    }
}